import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DigitalIdCardSelect from './DigitalIdCardSelect';
import DigitalIdCardTypeSelect from './DigitalIdCardTypeSelect';
import styles from './DigitalIdCard.module.sass';

const DigitalIdCardRow = ({ model, options, index, cardTypes, selectedTemplateName }) => {
  const cardTypeLabel = cardTypes.find(cardType => cardType.value === model.card_type)
  const [selectedCard, setSelectedCard] = useState({ label: selectedTemplateName || '', value: model.template_id || '' });
  const [selectedCardType, setSelectedCardType] = useState({ label: cardTypeLabel && cardTypeLabel.label || '', value: model.card_type || '' });
  const [selectedFile, setSelectedFile] = useState(null);

  const setInputs = (card) => {
    setSelectedCard(card);
  }

  const setType = (type) => {
    setSelectedCardType(type);
  }

  return (
    <fieldset className="row">
      <div className="col-xs-3">
        <DigitalIdCardSelect
          handleChange={setInputs}
          index={index}
          options={options}
          selectedValue={selectedCard}
          showCheckbox={true}
          placeholderText='Select Template'
        />
      </div>
      <div className="col-xs-3">
        <DigitalIdCardTypeSelect
          handleChange={setType}
          index={index}
          options={cardTypes}
          selectedValue={selectedCardType}
          showCheckbox={true}
          placeholderText='Select Type'
        />
      </div>
      <div className="col-xs-3">
        {selectedCardType.value && !selectedCardType.value.includes('default') && (
          <input
            className={styles.csvInput}
            onChange={(e) => {
              const file = e.target.files[0];
              let input = document.getElementById('test');

              let reader = new FileReader();
              reader.onload = function() {
                input.value = reader.result;
              }
              reader.readAsDataURL(file);
            }}
            type="file"
          />
        )}
        <input
          hidden
          name={`school[digital_id_cards_attributes][${index}][csv]`}
          className={styles.csvInput} />
      </div>
      <div className="col-xs-3">
        <input
          type="checkbox"
          name={`school[digital_id_cards_attributes][${index}][_destroy]`}
        />
      </div>
    </fieldset>
  );
};

DigitalIdCardRow.propTypes = {
  model: PropTypes.object,
  options: PropTypes.array,
  index: PropTypes.number,
  selectedTemplateName: PropTypes.string
};

DigitalIdCardRow.defaultProps = {
  model: { slug: '' },
  options: [{}],
  index: 0,
  selectedTemplateName: ''
};

export default DigitalIdCardRow;
